import React, { createContext, useEffect, useContext, useState } from 'react';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessionId, setSessionId] = useState();

  useEffect(() => {
    const fetchSessionId = async () => {
      try {
        console.log(process.env.REACT_APP_NODE_URL)
        const response = await fetch(`${process.env.REACT_APP_NODE_URL}/session`, {
            method: 'POST',
          });
        if (!response.ok) throw new Error('Failed to fetch session ID');

        const data = await response.json();
        const newId = data.session_id;

        localStorage.setItem('session_id', newId);
        setSessionId(newId);
      } catch (error) {
        console.error('Error generating session ID:', error);
      }
    };

    if (!sessionId) {
      fetchSessionId();
    }
  }, [sessionId]);

  return (
    <SessionContext.Provider value={sessionId}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSessionId = () => useContext(SessionContext);
